module.exports = __webpack_public_path__ + "static/media/Icon_Ortschaft.1118aee7.png";